<template>
  <modal name="bulkCreateEventsModal" :width="'75%'" :height="'auto'"
            :scrollable="true" :pivotX="1.0" :minWidth="900" @before-open="beforeOpen"
            :clickToClose="true" class="bulk-create-events-modal">
    <div class="bulk-create-events">
      <div class="bulk-title">
        <p>{{ getClientName }}  - Bulk Create Events</p>
        <button class="btn-bulk" @click="onDownload" :disabled="downloadLoading">
          <img src="../../../static/img/Union.svg" alt="union" v-if="!downloadLoading"/>
          <b-spinner v-if="downloadLoading"></b-spinner>
          Download Template
        </button>
      </div>
      <div class="upload-file">
        <vue-dropzone
          ref="myVueDropzone"
          :include-styling="false"
          :useCustomSlot="true"
          id="dropzone"
          :options="dropzoneOptions"
          @vdropzone-file-added="sendingFile"
        >
          <div class="dropzone-container">
            <img src="../../../static/img/cloud.svg" alt="union"/>
            <p class="text-csv">CSV File Only</p>
            <p class="text-drop">Drag & drop to upload or <a href="#">browse</a></p>
          </div>
        </vue-dropzone>
      </div>
      <hr/>
      <div class="submission-history">
        <p>Submission History</p>
        <table>
          <tr>
            <th v-for="item in historyHeader" :key="item">{{item}}</th>
          </tr>
          <tr v-if="loadingHistories">
            <td colspan="6" class="text-center"><b-spinner variant="primary"></b-spinner></td>
          </tr>
          <ItemHistoryModal 
            v-if="!loadingHistories"
            v-for="itemHistory in histories" :key="itemHistory.id" 
            :item="itemHistory"
            :clientId="clientId"
          />
        </table>
        <div class="pagination-container">
          <p class="total-text">{{totalRows}} results</p>
          <b-pagination 
            v-model="currentPage" 
            :total-rows="totalRows" 
            :per-page="itemsPerPage"
            pills
            :first-number="true"
            :last-number="true"
            @change="onChangePagination"
          ></b-pagination>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import vue2Dropzone from 'vue2-dropzone';
  import 'vue2-dropzone/dist/vue2Dropzone.min.css';
  import consts from '../../_consts';
  import ItemHistoryModal from './ItemHistoryModal';

  export default {
    name: 'BulkCreateEvents',
    components: {
      vueDropzone: vue2Dropzone,
      ItemHistoryModal
    },
    data () {
      return {
        historyHeader: ['Submission Date', 'Program', '# Events', 'File Name', 'Error Message', 'Pass/Fail'],
        dropzoneOptions: {
          url: 'http://localhost',
          includeStyling: false,
          previewsContainer: false,
          uploadMultiple: false,
          autoProcessQueue: false
        },
        downloadLoading: false,
        currentPage: 1,
        totalRows: 0,
        itemsPerPage: 10,
        clientId: null,
        histories: null,
        loadingHistories: false
      };
    },
    methods: {
      beforeOpen () {
        this.clientId = localStorage.getItem(consts.LOCAL_STORE.clientId);
        this.onGetHistories();
      },
      sendingFile (file) {
        let formData = new FormData();
        formData.append('content', file);
        formData.append('clientId', this.clientId);
        this.uploadFileBulkCreateEvent(formData).then(response => {
          this.currentPage = 1;
          this.onGetHistories();
          if (response.message.toLowerCase().includes('duplicated')) {
            this.$toast.error('Events failed to be processed because duplication was detected, please edit the CSV file and resubmit it', '', {
              ...this.$toastOpt.optInfo
            });
            return;
          }
          if (response.message === '') {
            this.$toast.success('Events are successfully uploaded and created', '', {
              ...this.$toastOpt.optInfo
            });
            return;
          }
          this.$toast.error(response.message, '', {
            ...this.$toastOpt.optInfo
          });
        });
      },
      onDownload () {
        this.downloadLoading = true;
        this.downloadBulkEventsTemplate().then(response => {
          const blob = new Blob([response], { type: 'text/csv' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = 'EventsTemplate.csv';
          link.click();
          URL.revokeObjectURL(link.href);
        }).finally(() => {
          this.downloadLoading = false;
        });
      },
      onChangePagination (page) {
        this.currentPage = page;
        this.onGetHistories();
      },
      onGetHistories () {
        this.loadingHistories = true;
        this.getUploadHistories({
          currentPage: this.currentPage,
          itemsPerPage: this.itemsPerPage,
          clientId: this.clientId
        }).then(response => {
          this.histories = response.histories;
          this.totalRows = response.totalUploaded;
        }).catch(() => {
          this.$toast.error('Events failed to be processed, please edit the CSV file and resubmit it', '', {
            ...this.$toastOpt.optInfo
          });
        }).finally(() => {
          this.loadingHistories = false;
        });
      },
      ...mapActions({
        downloadBulkEventsTemplate: 'ACTION_DOWNLOAD_BULK_EVENTS_TEMPLATE',
        uploadFileBulkCreateEvent: 'ACTION_UPLOAD_FILE_BULK_CREATE_EVENTS',
        getUploadHistories: 'ACTION_GET_UPLOAD_HISTORIES'
      })
    },
    mounted () {},
    computed: {
      ...mapGetters({
        getClientName: 'GETTERS_GET_CLIENT_NAME'
      })
    }
};
</script>


// WEBPACK FOOTER //
// BulkCreateEvents.vue?455e7130